import {useMemo} from 'react';
import {countries, CountryCodeType} from '@resurs-internal/rb-app-api';
import {useSearch} from '@tanstack/react-router';
import {useLocalState} from './useLocalState';

export const useCountryParam = () => {
  // used on multiple pages, so from is not specified
  const searchParams = useSearch({strict: false});
  const [localCountry, setLocalCountry] = useLocalState('user-country');

  const country = useMemo(() => {
    if (searchParams.country) {
      const countryCode = searchParams.country?.toUpperCase();
      const matchingCountry = Object.values(countries).find(
        (c) => c.code === countryCode,
      );
      return matchingCountry ?? countries.SE;
    }

    if (localCountry) {
      const matchingCountry = Object.values(countries).find(
        (c) => c.code === localCountry,
      );

      return matchingCountry ?? countries.SE;
    }

    const browserLangCode = navigator.language.split('-')[0];
    const languageCode = browserLangCode === 'no' ? 'nb' : browserLangCode; // Browsers return "no" instead of "nb"
    const matchingCountry = Object.values(countries).find(
      (c) => c.language === languageCode,
    );
    return matchingCountry ?? countries.SE;
  }, [searchParams.country, localCountry]);

  const setCountry = (countryCode: CountryCodeType) => {
    setLocalCountry(countryCode);
  };

  return {country, setCountry};
};
